<template>
  <section class="ugc-tools">
    <ugc-tools-controls-wrapper
      :showDefaultControl="showConfirmationControls"
      :activeControl="activeControl"
    ></ugc-tools-controls-wrapper>
    <div class="ugc-tools-container text-center">
      <carousel
        :perPage="4.55"
        :perPageCustom="[[640, 5]]"
        :paginationEnabled="false"
        :navigationEnabled="isWindowDesktop"
        :scrollPerPage="false"
        :centerMode="true"
        navigationPrevLabel="<span class='carousel-arrows icon-arrow-left-indicator-open'></span>"
        navigationNextLabel="<span class='carousel-arrows icon-arrow-right-indicator-open'></span>"
      >
        <slide
          v-for="icon in getControls"
          :key="`ugc-tools-${icon.icon_name}`"
        >
          <v-popover
            class="ugc-tools-container-popover"
            placement="top"
            trigger="hover click"
            popoverClass="ugc-tools-container-v-popover"
            container=".ugc-tools-container"
          >
            <button
              :class="[
                'ugc-tools-button',
                `ugc-tools-${icon.icon_name}`,
                { disabled: shouldToolBeDisabled(icon) }
              ]"
              @click="iconClickEvent($event, icon)"
              :disabled="shouldToolBeDisabled(icon)"
              :aria-label="translations[icon.display_name]"
            >
              <span
                :class="[
                  'icon',
                  activeIcon === icon.icon_name ? 'active' : '',
                  `icon-${icon.icon_name}`,
                  { 'hide': $store.state.utils.configuration.enableNewUgcModal },
                ]"
              ></span>
              <customs-svg-icon
                v-if="$store.state.utils.configuration.enableNewUgcModal"
                :src="`${ customsAssets }/svg/customizer/icon-${ icon.svg_icon }${ activeIcon === icon.icon_name ? '-white' : '' }.svg`"
                :class="[
                  'icon',
                  `svg-icon-${icon.svg_icon}`,
                  activeIcon === icon.icon_name ? 'active' : ''
                ]"
                aria-hidden="true"
              ></customs-svg-icon>
              <div class="text-icon">{{ translations[icon.display_name] }}</div>
              <div
                v-if="$store.state.utils.configuration.enableNewUgcModal"
                class="icon-check-svg"
                v-show="activeControls.includes(icon.name)"
              >
                <customs-svg-icon
                  :src="`${ customsAssets }/svg/customizer/icon-checkmark-inside-circle.svg`"
                  aria-hidden="true"
                ></customs-svg-icon>
              </div>
              <div
                v-else
                class="icon-check"
                v-show="activeControls.includes(icon.name)"
              ></div>
            </button>

            <template v-if="showTooltip(icon)" slot="popover">
              <div class="ugc-tools-container-popover-content">
                {{ translations.ugcToolTipSorryMessage }}
              </div>
            </template>
          </v-popover>
        </slide>
      </carousel>
    </div>
  </section>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import ugcToolsControlsWrapper from '@/components/UGC/Tools/ControlsWrapper';
import customsSvgIcon from '@/components/Globals/SvgIcon';
const iconsToAttachTooltip = ["pop-art", "tile"];

export default {
  name: "UgcTools",
  components: {
    Carousel,
    Slide,
    ugcToolsControlsWrapper,
    customsSvgIcon,
  },
  data() {
    return {
      activeControl: "",
      activeIcon: "",
      disableButtons: false,
      lastCanvasJson: null,
      showConfirmationControls: false
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    activeControls() {
      return this.$store.getters["ugc/stateManager/activeControls"];
    },
    isFabricLoading() {
      return this.$store.state.ugc.stateManager.isLoading;
    },
    iconsArray() {
      return this.$store.state.utils.configuration.ugc.ugcTools;
    },
    getControls() {
      const ugcToolsFromURL = this.$store.state.utils.queryParams.ugcTools ? this.$store.state.utils.queryParams.ugcTools.split(",") : null;
      const ugcLoadingFromEntrypoint = this.$store.state.ugc.isUGCLoadingFromEntrypoint;
      const secondaryImage = this.$store.state.utils.queryParams.secondaryImage || this.$store.state.utils.queryParams.cbtImage;
      const { ugcFeature = null, ugc_image_id = null, replaceComponentFeature, activeUGCComponent } = this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex];
      const isPrecreated = this.$store.state.utils.queryParams.recipe || false;
      const activeIndex = this.$store.state.ugc.tempData.activeUGCIndex;
      let controls = [];
      if (this.$store.getters["utils/isGCC"]) {
        for (let item of this.iconsArray) {
          if (item.gcc_allowed) {
            controls.push(item);
          }
        }
      } else if (activeIndex === 1) {
        controls = this.iconsArray.filter(tool => !tool.ugcFeatureDisabled?.includes("imageLibrary"));
      } else if (ugcLoadingFromEntrypoint  && ugcToolsFromURL) {
        controls = this.iconsArray.filter(tool => ugcToolsFromURL.includes(tool.name));
        if (!controls.length) controls = this.iconsArray;
      } else if ( 
        ( ugcFeature && (secondaryImage === ugc_image_id || 
          this.$store.getters['ugc/tempData/originalImageId'] === this.$store.state.utils.queryParams.ugcImage) && 
          replaceComponentFeature.indexOf(activeUGCComponent) < 0  
        ) ||
        ( ugcFeature && isPrecreated && 
          replaceComponentFeature.indexOf(activeUGCComponent) < 0 
        )) {
        controls = this.iconsArray.filter(tool => {
          // the tool is enabled by default, unless the current feature is in "ugcFeatureDisabled" array
          const ugcFeatureDisabledArray = tool.ugcFeatureDisabled;
          if (!Array.isArray(ugcFeatureDisabledArray)) return true;
          return !ugcFeatureDisabledArray.includes(ugcFeature);
        });
      } else if (secondaryImage) {
        controls = this.iconsArray;
        const index = this.iconsArray.findIndex(el => el.name === 'replace');
        if(index >= 0) controls.splice(index, 1);
      } else {
        controls = this.iconsArray;
      }
      return controls;
    },
    isPopArtOrTileApplied() {
      return this.$store.state.ugc.stateManager.isPopArtOrTileApplied;
    },
    isWindowDesktop() {
      return this.$store.state.utils.screenSize !== "small";
    },
    customsAssets() {
      return this.$store.state.endPoints.customizer.customsAssets;
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    minPlacementSize() {
      const { activeUGCComponent,  } = this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex];
      const {pdmModel} = this.$store.state.utils;
      const minPlacementSize = this.$store.state.utils.configuration.ugc.minPlacementSize;
      const minWidth = this.$store.state.utils.configuration.ugc.minPlacementSize;
      // Sk8-hi quarters placement is square, if that changes we can move this to the pdm
      const minHeight = pdmModel !== 'sk8-hi' && activeUGCComponent === 'quarters' ? minPlacementSize * 2 : minPlacementSize;
      return {minWidth,minHeight}
    }
  },
  methods: {
    /**
     * Sets the current active control
     *
     */
    iconClickEvent(e, icon) {
      this.$nextTick(() => {
        this.lastCanvasJson = this.$store.state.ugc.stateManager.canvas.toJSON();
      })
      this.showConfirmationControls = icon.show_confirmation_controls;
      this.activeControl = icon.vueComponent;
      this.activeIcon = icon.icon_name;
      this.$store.commit(
        "ugc/stateManager/SET_ACTIVE_CONTROL",
        this.activeControl
      );
      if (this.$store.state.utils.queryParams.feature !== 'checkerboarder') {
        let eventAction = this.$store.state.transferDesign.isCustomizerTransferredModel ? 'transferDesign' : 'ugc';
        eventAction = this.activeUGCIndex !== 1 ? eventAction : 'imageLibrary';
        this.$ugcDataLayer.logAnalyticsEvent({
          action: eventAction,
          type: this.$ugcDataLayer.types.clickUgctool,
          eventLabel: icon.name
        });
      }
    },
    /**
     * Gets called when any control notifies that it was applied
     *
     * @public
     */
    onControlFinish(control) {
      this.$store.dispatch("ugc/stateManager/STORE_STEP", { control });
      this.clearSelectedControl();
      this.$eventBus.$emit("hide-ugc-intructions");
      if (!control) {
        this.$store.commit("ugc/stateManager/CLEAR");
      }
    },
    /**
     * Clears the current selected control
     * @public
     */
    clearSelectedControl() {
      this.resetActiveControl();
      this.showConfirmationControls = false;
    },
    /**
     * Resets the active control
     * @public
     */
    resetActiveControl() {
      this.activeControl = "";
      this.activeIcon = "";
      this.$store.commit(
        "ugc/stateManager/SET_ACTIVE_CONTROL",
        this.activeControl
      );
    },
    /**
     * Set active icon
     * @public
     */
    setActiveControl(componentName) {
      const ugcTool = this.iconsArray.find(
        ({ vueComponent }) => vueComponent === componentName
      );
      if (ugcTool) {
        this.activeIcon = ugcTool.icon_name;
        if(componentName !== "ugc-replace-image-control") {
          this.activeControl = componentName;
          this.showConfirmationControls = ugcTool.show_confirmation_controls;
        }
        this.$store.commit(
          "ugc/stateManager/SET_ACTIVE_CONTROL",
          componentName
        );
      }
    },
    onControlCancel() {
      if(this.lastCanvasJson) {
        this.$store
          .dispatch("ugc/stateManager/LOAD_CANVAS_JSON", this.lastCanvasJson)
          .then(() => {
            this.$eventBus.$emit("reload-placement-guide");
            this.clearSelectedControl();
          });
      } else {
        this.clearSelectedControl();
        console.error("lastCanvasJson is null")
      }
    },
    shouldToolBeDisabled(icon) {
      const activeIndex = this.$store.state.ugc.tempData.activeUGCIndex;
      if (
        this.isFabricLoading
        || !this.$store.state.ugc.stateManager.canvas
        || this.$store.state.ugc.tempData.features[activeIndex].placementViewOrder !== 0
      ) return true;
      const image = this.$store.state.ugc.stateManager.canvas.getObjects("image")[0];
      if(
        (icon.name === 'zoom' || icon.name === 'crop') &&
        (image?.width < this.minPlacementSize.minWidth || image?.height < this.minPlacementSize.minHeight )
      ) return true
      const { disableBg } = this.$store.state.ugc.tempData.features[activeIndex ];
      const backgroundDisabled =
        icon.icon_name === "background-color" && disableBg;
      const disableTileOrPopArt =
        this.isPopArtOrTileApplied && icon.disableTileOrPopArt ? true : false;
      if (this.activeControl === "ugc-replace-image-control") {
        return disableTileOrPopArt || backgroundDisabled || false;
      }
      const toolDisabled =
        this.activeIcon !== "" && this.activeIcon !== icon.icon_name;
      return toolDisabled || disableTileOrPopArt || backgroundDisabled;
    },
    canvasTransformEvents(evt) {
      if (this.activeControl) return;
      const { action } = evt.transform;
      if (action.includes("rotate")) {
        this.iconClickEvent(null, this.iconsArray.find(e => e.name === "rotate"));
      }
    },
    resetToDefaultState() {
      this.clearSelectedControl();
      this.$store.commit("ugc/stateManager/RESET");
      this.$eventBus.$emit("hide-ugc-intructions", true);
    },
    onMouseWheel() {
      if (
        !this.activeIcon &&
        this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].placementViewOrder === 0
      ) {
        this.iconClickEvent(null, this.iconsArray.find(e => e.name === "zoom"));
      }
    },
    /**
     * Shows tooltip when tile or popart are disabled
     */
    showTooltip(icon) {
      if (this.isPopArtOrTileApplied && iconsToAttachTooltip.includes(icon.name)) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.$eventBus.$on("control-finish", this.onControlFinish);
    this.$eventBus.$on("confirmation-controls:cancel", this.onControlCancel);
    this.$eventBus.$on("reset-active-control", this.clearSelectedControl);
    this.$eventBus.$on("set-active-control", this.setActiveControl);
    this.$eventBus.$on(
      "ugc-tools-clear-all-selected",
      this.resetToDefaultState
    );
    this.$eventBus.$on("canvas:mousewheel", this.onMouseWheel);
    this.$eventBus.$on("ugc-canvas-stored", () => {
      this.$store.state.ugc.stateManager.canvas.on(
        "before:transform",
        this.canvasTransformEvents
      );
    });
  },
  beforeDestroy() {
    this.$eventBus.$off("control-finish", this.onControlFinish);
    this.$eventBus.$off("confirmation-controls:cancel", this.onControlCancel);
    this.$eventBus.$off("reset-active-control", this.resetActiveControl);
    this.$eventBus.$off("set-active-icon", this.setActiveIcon);
    this.$eventBus.$off(
      "ugc-tools-clear-all-selected",
      this.resetToDefaultState
    );
    this.$eventBus.$off("canvas:mousewheel", this.onMouseWheel);
    if (this.$store.state.ugc.stateManager.canvas) {
      this.$store.state.ugc.stateManager.canvas.off(
        "before:transform",
        this.canvasTransformEvents
      );
    }
  }
};
</script>
